<template>
    <section class="our-products">
        <swiper class="our-products__swiper" v-bind="swiperOptions">
            <swiper-slide class="our-products__slide" v-for="(partner,i) in partners" :key="i">
                <a class="our-products__item" :href="partner.link">
                    <div class="our-products__wrap-img">
                        <img class="our-products__img" :src="getImg(partner)" :alt="partner.img" :title="partner.title">
                    </div>
                    <div class="our-products__text">
                        <div>
                            <h3 class="our-products__title">{{ partner.title[lang] }}</h3>
                            <p class="our-products__description size-14-500">{{partner.description[lang]}}</p>
                        </div>
                        <img :src="require('@/assets/arrow-line.svg')" alt="arrow" style="width: 15px">
                    </div>
                </a>
            </swiper-slide>
        </swiper>
    </section>
</template>

<script>
import { Swiper, SwiperSlide } from 'swiper/vue';
import 'swiper/css';
import 'swiper/css/autoplay'

import { Autoplay, } from "swiper";
export default {
    name: "OurPartners",
    props:{
        srcImg: String,
        data: [Array],
    },
    data(){
        return {
            defaultValue: [
                {
                    "title": {
                        "en": "xTrack",
                        "es": "xTrack",
                        "pt": "xTrack"
                    },
                    "description": {
                        "en": "Track with precision: Real-time visibility and control.",
                        "es": "Track with precision: Real-time visibility and control.",
                        "pt": "Track with precision: Real-time visibility and control."
                    },
                    "link": "/product/xtrack",
                    "pathImg": "products/xTrack/",
                    "img": "xTrack-min"
                },
                {
                    "title": {
                        "en": "xTrack Asset",
                        "es": "xTrack Asset",
                        "pt": "xTrack Asset"
                    },
                    "description": {
                        "en": "Secure Assets: Advanced, comprehensive tracking.",
                        "es": "Secure Assets: Advanced, comprehensive tracking.",
                        "pt": "Secure Assets: Advanced, comprehensive tracking."
                    },
                    "link": "/product/xtrack-assets",
                    "pathImg": "products/xTrack/",
                    "img": "xTrack-assets-min"
                },
                {
                    "title": {
                        "en": "ProVision",
                        "es": "ProVision",
                        "pt": "ProVision"
                    },
                    "description": {
                        "en": "Experience real-time video streaming with high-definition clarity",
                        "es": "Experience real-time video streaming with high-definition clarity",
                        "pt": "Experience real-time video streaming with high-definition clarity"
                    },
                    "link": "/product/provision",
                    "pathImg": "products/proVision/",
                    "img": "proVision-min"
                },
                {
                    "title": {
                        "en": "xCool",
                        "es": "xCool",
                        "pt": "xCool"
                    },
                    "description": {
                        "en": "Reefer Control: Precision temperature monitoring.",
                        "es": "Reefer Control: Precision temperature monitoring.",
                        "pt": "Reefer Control: Precision temperature monitoring."
                    },
                    "link": "/product/xcool",
                    "pathImg": "products/xCool/",
                    "img": "xCool-min"
                },
                {
                    "title": {
                        "en": "xCargo",
                        "es": "xCargo",
                        "pt": "xCargo"
                    },
                    "description": {
                        "en": "The xCargo Dashboard delivers real-time operational insights",
                        "es": "The xCargo Dashboard delivers real-time operational insights",
                        "pt": "The xCargo Dashboard delivers real-time operational insights"
                    },
                    "link": "/product/xcargo",
                    "pathImg": "products/xCargo/",
                    "img": "xCargo-dashboad-min"
                },
                {
                    "title": {
                        "en": "xCargo Vision",
                        "es": "xCargo Vision",
                        "pt": "xCargo Vision"
                    },
                    "description": {
                        "en": "xCargo Vision integrates high-definition, AI-powered cameras directly into cargo environments",
                        "es": "xCargo Vision integrates high-definition, AI-powered cameras directly into cargo environments",
                        "pt": "xCargo Vision integrates high-definition, AI-powered cameras directly into cargo environments"
                    },
                    "link": "/product/xcargo-vision",
                    "pathImg": "products/xCargo/",
                    "img": "xCargo-vision-min"
                },
                {
                    "title": {
                        "en": "xELD",
                        "es": "xELD",
                        "pt": "xELD"
                    },
                    "description": {
                        "en": "The xELD Dashboard gives fleet managers a central hub to monitor driver logs",
                        "es": "The xELD Dashboard gives fleet managers a central hub to monitor driver logs",
                        "pt": "The xELD Dashboard gives fleet managers a central hub to monitor driver logs"
                    },
                    "link": "/product/xeld",
                    "pathImg": "products/xELD/",
                    "img": "XELD-min"
                },
                {
                    "title": {
                        "en": "xApps",
                        "es": "xApps",
                        "pt": "xApps"
                    },
                    "description": {
                        "en": "Stay connected with Mobile Apps",
                        "es": "Stay connected with Mobile Apps",
                        "pt": "Stay connected with Mobile Apps"
                    },
                    "link": "/product/xapps",
                    "pathImg": "products/xApps/",
                    "img": "xApps-min"
                }
            ],
            swiperOptions:{
                centeredSlides:true,
                slidesPerView: 1.5,
                loopedSlides: 4.5,
                spaceBetween: 10,
                autoplay: {
                    delay: 2500,
                    disableOnInteraction: false,
                },
                breakpoints:{
                    320:{
                        slidesPerView: 1.1
                    },
                    500:{
                        slidesPerView: 1.4
                    },
                    690:{
                        slidesPerView: 1.4
                    },
                    845:{
                        slidesPerView: 1.8
                    },
                    941:{
                        slidesPerView: 2
                    },
                    1491:{
                        slidesPerView: 3.2
                    },
                    1645:{
                        slidesPerView: 3.5
                    },
                    1870:{
                        slidesPerView: 4
                    }
                },
                loop: true,
                observe: true,
                observeParents: true,
                observeSlideChildren: true,
                speed:1000,
                modules:[Autoplay]
            }
        }
    },
    components:{
        Swiper,
        SwiperSlide,
    },
    computed: {
        lang() {
            return this.$i18n.locale
        },
        partners(){
            return this.data || this.defaultValue
        },

    },
    methods: {
        getImg(item) {
            let img = item.img;
            let pathImg = item?.pathImg || this.srcImg || 'other/';
            return require('@/assets/'+pathImg+img+'.png');
        }
    }
}
</script>

<style scoped lang="scss">
.our-products {
    padding: 60px 0 45px 0;
    &__item {
        display: flex;
        background: white;
        height: 200px;
        width: 465px;
        padding: 25px 15px;
        border-radius: 16px;
        gap: 15px;
    }
    &__wrap-img {
        width: 50%;
        display: flex;
        justify-content: center;
        align-items: center;
    }
    &__text {
        width: 50%;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
    }
    &__description {
        //width: 160px;
    }
    &__img {
        max-height: 100%;
        max-width: 100%;
        width: auto;
    }
    &__title {
        margin-bottom: 10px;
    }
    //&__wsiper {
    //    height: 208px;
    //}
    //&__slide {
    //    background: white;
    //    width: 440px;
    //    height: 208px;
    //}
    //a {
    //    height: 100%;
    //}
}
@media all and (max-width: 690px) {
    .our-products {
        &__item {
            width: 100%;
        }
    }
}
@media all and (max-width: 350px) {
    .our-products {
        &__item {
            width: 100%;
            height: 250px;
        }
    }
}
</style>